export default __webpack_public_path__ + "static/media/aesthetics.3322a8d0.png";